import type { PaymentMethodResponse } from '@kimuno/api-sdk';

import { UserPaymentMethodType } from '../types/User';
import type { IconName } from './getMuiIcon';

export const paymentMethodMap = (
	paymentMethod: PaymentMethodResponse
): { text: string; icon: IconName } => {
	switch (paymentMethod.type) {
		case UserPaymentMethodType.SEPA:
			return {
				text: paymentMethod.sepa?.iban ?? '',
				icon: UserPaymentMethodType.SEPA,
			};
		case UserPaymentMethodType.PAYPAL:
			return {
				text: paymentMethod.paypal?.email ?? '',
				icon: UserPaymentMethodType.PAYPAL,
			};
		case UserPaymentMethodType.CREDIT_CARD:
			return {
				text: paymentMethod.creditCard?.number ?? '',
				icon: UserPaymentMethodType.CREDIT_CARD,
			};
		case UserPaymentMethodType.BANK_TRANSFER:
			return {
				text: paymentMethod.bankTransfer?.iban ?? '',
				icon: UserPaymentMethodType.SEPA,
			};
		default:
			return { text: '', icon: UserPaymentMethodType.INVOICE };
	}
};
